import ProjectUtil, {ProjectNode} from '../../ProjectUtil';
import {TimeRegistrationNotAllowedReason} from './TimeRegistrationNotAllowedReason';

import {
	isDoneTaskTimeRegistrationAllowed,
	isTimeRegistrationTaskAssignmentRequired,
} from '../../cache/TimeRegistrationSettingsUtil';

function notDoneClause(statusColumnCategory: string | null): boolean {
	if (!isDoneTaskTimeRegistrationAllowed()) {
		return statusColumnCategory !== 'DONE';
	}
	return true;
}

function assignmentClause(personId: string, assignedPersonIds: string[]): boolean {
	if (isTimeRegistrationTaskAssignmentRequired()) {
		return assignedPersonIds?.includes(personId);
	}
	return true;
}

function noManualProgressClause(project: ProjectNode | null): boolean {
	return !ProjectUtil.projectUsesManualProgress(project);
}

export function isTaskTimeRegistrationAllowed(
	statusColumnCategory: string,
	personId: string,
	assignedPersonIds: string[],
	project: ProjectNode | null
): boolean {
	return (
		notDoneClause(statusColumnCategory) && assignmentClause(personId, assignedPersonIds) && noManualProgressClause(project)
	);
}

export function getTaskTimeRegistrationNotAllowedWithReason(
	statusColumnCategory: string | null,
	personId: string,
	assignedPersonIds: string[]
): TimeRegistrationNotAllowedReason | null {
	if (!notDoneClause(statusColumnCategory)) {
		return TimeRegistrationNotAllowedReason.NoDoneTask;
	}
	if (!assignmentClause(personId, assignedPersonIds)) {
		return TimeRegistrationNotAllowedReason.NoUnassignedTask;
	}

	return null;
}
